import React, { useState, useEffect,  } from "react";
import { NavLink, useLocation } from "react-router-dom";
import PropTypes from "prop-types";

const Sidebar = ({ isCollapsedFromHeader, sidebarRef }) => {
  const [openMenus, setOpenMenus] = useState({});
  const location = useLocation();
  /** Handle responsive collapse *

  /** Sync collapse state from header *

  /** Toggle dropdown menu */
  const toggleMenu = (key) => {
    setOpenMenus((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  /** Toggle full sidebar collapse */
  // const toggleSidebar = () => {
  //   setSidebarCollapsed((prev) => !prev);
  // };

  /** Menu Configuration (easy to expand later) */

 
  const menuItems = [
    {
      category: "Main",
      icon: "bx bx-grid-alt", // 🏠 Example icon for Main
      items: [
        {
          label: "Dashboard",
          icon: "bx bx-home",
          to: "/dashboard",
        },
      ],
    },
  
    {
      category: "Management",
      icon: "bx bx-user-circle", // 👤 Example icon for User Management
      items: [
        {
          label: "Doctor",
          icon: "bx bx-briefcase-alt-2", // 💬 Use proper chat icon
          to: "/docters",
        },
        {
          label: "Patient",
          icon: "bx bx-group", // 🔔 Notification icon
          to: "/patients",
        },
      ],
    },
    {
      category: "Tools",
      icon: "bx bx-wrench",
      items: [
        {
          label: "Qualification",
          icon: "bx bx-certification", 
          to: "/qualification",
        },
        {
          label: "Specialities",
          icon: "bx bx-plus-medical", 
          to: "/speciality",
        },
        {
          label: "Medical Council",
          icon: "bx bx-building", 
          to: "/medical-councils",
        },
        {
          label: "Laboratory Categories",
          icon: "bx bx-category",
          to: "/laboratory-category",
        },        
        {
          label: "laboratory",
          icon: "bx bx-test-tube", 
          to: "/laboratory",
        },

        {
          label: "Banner",
          icon: "bx bx-image",
          to: "/banner",
        }
        

        
      ],
    },    
    {
      category: "payments",
      icon: "bx bx-credit-card",
      items: [
        {
          label: "Payment Details",
          icon: "bx bx-receipt",
          to: "/payments",
        },
      ],
    },    
    {
      category: "Community",
      icon: "bx bx-bar-chart-alt-2", // 📊 Example icon for category
      items: [
        // {
        //   label: "Chat",
        //   icon: "bx bx-chat", // 💬 Use proper chat icon
        //   to: "/chat",
        // },
        {
          label: "Notification",
          icon: "bx bx-bell", // 🔔 Notification icon
          to: "/notification",
        },
      ],
    },  
   
  ];
  

  return (
    <aside
      id="sidebar"
      ref={sidebarRef}
      className={`app-sidebar sticky sticky-pin ${isCollapsedFromHeader ? "open" : ""}`}
 
    >
      {/* --- Sidebar Header --- */}
      <div className={`main-sidebar-header bg-gradient`}
      >
        <a href="#" className="header-logo">

           <img
            src="New/assets/images/brand-logos/desktop-dark.png"
            alt="logo"
            className="toggle-logo"
          />
            <img
          src="New/assets/images/brand-logos/faq-logo.png"
          alt="logo"
          className="desktop-logo"
        />
        </a>
      </div>

      {/* --- Sidebar Navigation --- */}
      <div className="main-sidebar" id="sidebar-scroll">
        <nav className="main-menu-container nav nav-pills flex-column sub-open">
          <ul className="main-menu">
            {menuItems.map((section, sectionIdx) => (
              <React.Fragment key={sectionIdx}>
                <li className="slide__category">
                  <span className="category-name">{section.category}</span>
                </li>

                {section.items.map((item, idx) => (
                  <li
                    key={idx}
                    className={`slide ${
                      item.submenu ? "has-sub" : ""
                    } ${openMenus[item.submenuKey] ? "open" : ""}`}
                  >
                    {item.submenu ? (
                      <>
                        <a
                          href="#"
                          className="side-menu__item"
                          onClick={(e) => {
                            e.preventDefault();
                            toggleMenu(item.submenuKey);
                          }}
                        >
                          <i className={`${item.icon} side-menu__icon`} />
                          <span className="side-menu__label">{item.label}</span>
                          <i
                            className={`fe fe-chevron-right side-menu__angle ${
                              openMenus[item.submenuKey] ? "rotate-90" : ""
                            }`}
                          />
                        </a>
                        <ul
                          className="slide-menu child1"
                          style={{ display: openMenus[item.submenuKey] ? "block" : "none" }}
                        >
                          {item.submenu.map((sub, subIdx) => (
                            <li key={subIdx} className="slide">
                              <NavLink
                                to={sub.to}
                                className={({ isActive }) =>
                                  `side-menu__item ${isActive ? "active" : ""}`
                                }
                              >
                                {sub.icon && (
                                  <i className={`${sub.icon} me-2`} style={{ fontSize: 14 }} />
                                )}
                                {sub.label}
                              </NavLink>
                            </li>
                          ))}
                        </ul>
                      </>
                    ) : (
                      <NavLink
                        to={item.to}
                        className={({ isActive }) =>
                          `side-menu__item ${isActive ? "active" : ""}`
                        }
                      >
                        <i className={`${item.icon} side-menu__icon`} />
                        <span className="side-menu__label">{item.label}</span>
                      </NavLink>
                    )}
                  </li>
                ))}
              </React.Fragment>
            ))}
          </ul>
        </nav>
      </div>

      {/* --- Sidebar Toggle Button --- */}
      {/* <div className="sidebar-toggle-btn" onClick={toggleSidebar}> */}
        {/* <i className={`bx ${sidebarCollapsed ? "bx-menu" : "bx-x"}`} /> */}
      {/* </div> */}
    </aside>
  );
};

export default Sidebar;
